import { DOMAIN, WS_DOMAIN } from "../constants";

export const clsPrefix = 'cap-documentation-chat-bot';

export const ASK_AIRA_CHAT_FEEDBACK = `${DOMAIN}/arya/api/v1/ask-aira-service/doc_chat_bot/feedback`;

export const MOCK_WS_URL = 'ws://cap-doc-mock-websocket';
export const SERVER_URL = `${WS_DOMAIN}/arya/api/v1/ask-aira-service/doc_chat_bot/query_stream`
export const MESSAGE_LIKE = "MESSAGE_LIKE"
export const MESSAGE_DISLIKE = "MESSAGE_DISLIKE"

export const SEND_FEEDBACK_REQUEST = "SEND_FEEDBACK_REQUEST";
export const SEND_FEEDBACK_SUCCESS = "SEND_FEEDBACK_SUCCESS";
export const SEND_FEEDBACK_FAILURE = "SEND_FEEDBACK_FAILURE";

export const DOC_BOT_REDUCER_DOMAIN = 'DOC_BOT';